import {
  createContext,
  type PropsWithChildren,
  useContext,
  useState,
} from 'react';

import { DeleteWorkstreamModal } from './delete-workstream.modal';

export type DeleteWorkstreamModalOpen = { id: string } | undefined;

const DeleteWorkstreamModalContext = createContext<
  (open: DeleteWorkstreamModalOpen) => void
>(() => {
  // This is a no-op function used as the default value for the context
  // It will be overridden by the actual provider
});

export function useDeleteWorkstreamModal() {
  return useContext(DeleteWorkstreamModalContext);
}

export function DeleteWorkstreamModalProvider({
  children,
}: PropsWithChildren<object>) {
  const [open, setOpen] = useState<DeleteWorkstreamModalOpen>(undefined);

  return (
    <DeleteWorkstreamModalContext.Provider value={setOpen}>
      {children}
      <DeleteWorkstreamModal open={open} onClose={() => setOpen(undefined)} />
    </DeleteWorkstreamModalContext.Provider>
  );
}
